export default {
      id: "icon-ring-step-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "icons.svg#icon-ring-step",
      toString: function () {
        return this.url;
      }
    }